import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useIdpAuth } from '@/context/IdpAuth/IdpAuthContext';

import { Container, SairButton, Texto, Titulo } from './styles';

/**
 * A tela de quem autenticou no IDP e nao tem conta no Sapron.
 *
 * O auto-registro do IDP esta ligado e o Keycloak federa o Google: da para
 * chegar aqui com um token perfeito e nenhum vinculo. O app nao cria sessao
 * nesse caso — nem em memoria — e o callback ja encerrou a sessao SSO do
 * Keycloak antes de mostrar esta tela (logout federado). Por isso o "Sair" e,
 * em geral, so a volta ao `/login`: o proximo "Entrar com Seazone" pede
 * credencial de novo. Se o logout do callback falhou, o "Sair" o refaz antes, e
 * o Keycloak devolve o navegador ao `/login`.
 */
const SemConta = () => {
  const navigate = useNavigate();
  const { sairSemConta } = useIdpAuth();

  const sair = async () => {
    if (await sairSemConta()) return;
    navigate('/login');
  };

  useEffect(() => {
    document.title = 'Sapron | Sem conta';
  }, []);

  return (
    <Container>
      <Titulo>Sua conta Seazone ainda não tem acesso ao Sapron</Titulo>
      <Texto>
        O login funcionou, mas esta conta não está ligada a nenhum cadastro de proprietário,
        parceiro ou anfitrião no Sapron. Fale com o seu contato na Seazone para liberar o acesso.
      </Texto>
      <SairButton type="button" data-cy="sem-conta-sair" onClick={() => sair()}>
        Sair
      </SairButton>
    </Container>
  );
};

export default SemConta;
